import React from "react";
import { View, StyleSheet } from "react-native";

interface ShimmerGradientProps {
  /**
   * The shimmer colors for the gradient
   */
  colors: string[];
  /**
   * The locations for gradient stops
   */
  locations: number[];
}

/**
 * Web shimmer gradient component using CSS linear-gradient
 */
export function ShimmerGradient({ colors, locations }: ShimmerGradientProps) {
  // Convert colors and locations to CSS gradient format
  const gradientStops = colors
    .map((color, index) => {
      const location = locations[index] * 100;
      return `${color} ${location}%`;
    })
    .join(", ");

  return (
    <View
      style={[
        StyleSheet.absoluteFillObject,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- RN-5783 baseline: pre-existing cast; migrate to zod/proper types (see docs/type-assertions.md)
        {
          // Web-specific: Use CSS gradient instead of LinearGradient component
          background: `linear-gradient(90deg, ${gradientStops})`,
        } as any, // Type assertion needed for web-specific CSS property
      ]}
    />
  );
}
